import * as Mod1 from "./discourse/components/modal/policy-builder";
import * as Mod2 from "./discourse/components/policy-builder-form";
import * as Mod3 from "./discourse/components/policy-group-input";
import * as Mod4 from "./discourse/components/policy-reminder-input";
import * as Mod5 from "./discourse/components/post-policy";
import * as Mod6 from "./discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails.gjs";
import * as Mod7 from "./discourse/initializers/add-policy-builder";
import * as Mod8 from "./discourse/initializers/extend-for-policy";
import * as Mod9 from "./discourse/initializers/policy-admin-plugin-configuration-nav";
import * as Mod10 from "./discourse/initializers/rich-editor-extension";
import * as Mod11 from "./lib/discourse-markdown/policy";
import * as Mod12 from "./pre-initializers/policy-user-options";
const compatModules = {
  "discourse/components/modal/policy-builder": Mod1,
  "discourse/components/policy-builder-form": Mod2,
  "discourse/components/policy-group-input": Mod3,
  "discourse/components/policy-reminder-input": Mod4,
  "discourse/components/post-policy": Mod5,
  "discourse/connectors/user-preferences-emails-pref-email-settings/preferences-policy-emails": Mod6,
  "discourse/initializers/add-policy-builder": Mod7,
  "discourse/initializers/extend-for-policy": Mod8,
  "discourse/initializers/policy-admin-plugin-configuration-nav": Mod9,
  "discourse/initializers/rich-editor-extension": Mod10,
  "lib/discourse-markdown/policy": Mod11,
  "pre-initializers/policy-user-options": Mod12,
};
export { compatModules };
export default compatModules;
